import { render } from "./actionField.vue?vue&type=template&id=a4484f46&scoped=true"
import script from "./actionField.vue?vue&type=script&lang=js"
export * from "./actionField.vue?vue&type=script&lang=js"

import "./actionField.vue?vue&type=style&index=0&id=a4484f46&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4484f46"]])

export default __exports__